import { IMarketYoyGrowthPlanningDataApi } from '../api/types'
import { IMarketYoyGrowthPlanning, IMarketYoyGrowthPlanningData } from '../model/types'

import { mapMarketYoyGrowthCategoryFromApi } from './mapMarketYoyGrowthCategoryFromApi'
import { mapMarketYoyGrowthExpectationFromApi } from './mapMarketYoyGrowthExpectationFromApi'
import { mapMarketYoyGrowthGeoMarketFromApi } from './mapMarketYoyGrowthGeoMarketFromApi'
import { mapMarketYoyGrowthLogEntryFromApi } from './mapMarketYoyGrowthLogEntryFromApi'
import { mapMarketYoyGrowthPlanningFromApi } from './mapMarketYoyGrowthPlanningFromApi'
import { mapMarketYoyGrowthUserInfoFromApi } from './mapMarketYoyGrowthUserInfoFromApi'

export const mapMarketYoyGrowthPlanningDataFromApi = (
  data: IMarketYoyGrowthPlanningDataApi
): IMarketYoyGrowthPlanningData => {
  const planningApi = data.Planning?.[0]
  const planning: IMarketYoyGrowthPlanning = planningApi
    ? mapMarketYoyGrowthPlanningFromApi(planningApi)
    : {
        entryId: -1,
        uid: '',
        created: '',
        createdBy: '',
        modified: '',
        modifiedBy: '',
        fYear: -1,
        status: 'Draft',
        isLocked: true,
      }

  return {
    // `?? 0` is unreachable in practice — PlanningDetails never arrives without a Planning entry.
    planningDetails: (data.PlanningDetails ?? []).map((detail) =>
      mapMarketYoyGrowthExpectationFromApi(detail, planning?.fYear ?? 0)
    ),
    planning,
    userInfo: mapMarketYoyGrowthUserInfoFromApi(data.UserInfo),
    geoMarkets: (data.GeoMarkets ?? []).map(mapMarketYoyGrowthGeoMarketFromApi),
    categories: (data.Categories ?? []).map(mapMarketYoyGrowthCategoryFromApi),
    log: (data.Log ?? []).map(mapMarketYoyGrowthLogEntryFromApi),
  }
}
